import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Api } from '../../utils/api';


class EntityGroupElementsTable extends React.Component {

  constructor() {
    super();
    this.api = new Api();
  }

  componentDidMount() {
  }


  
  render() {

    let establishmentsList = this.props.establishmentsList;
    

    return (
      <div>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" width="400px">Nome do Equipamento</TableCell>
                <TableCell align="left" width="450px">Entidade Associada</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {establishmentsList && establishmentsList.map(establishment => (
                <TableRow key={establishment.id}>
                  <TableCell align="left">{establishment.name}</TableCell>
                  <TableCell align="left">{establishment.entity}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
});

EntityGroupElementsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(EntityGroupElementsTable));